import {cloneDeep} from "lodash"
import {cycleFieldsFragment, cycleQuestionGroupsFragment, cycleQuestionsFragment} from "../../gql/fragments/schedule"
import {insGlobal} from "../query/insGlobal"
import getPrivateQuestionGroupFromCycle from "../../helpers/getPrivateQuestionGroupFromCycle"
import {CLONE_PREFIX} from "../../constants"
import {questionFieldsFragment} from "../../gql/fragments/question"

const resolvers = {
  Mutation: {
    insWizard: (root, {params}, {cache}) => {
      const data = {
        insWizard: {__typename: "InsWizard", ...params}
      }
      cache.writeData({data})
    },
    insGlobal: (root, {params}, {cache}) => {
      const data = {
        insGlobal: {__typename: "InsGlobal", ...params}
      }
      cache.writeData({data})
      return data.insGlobal
    },
    insWizardCloneCycle: (root, args, {cache, getCacheKey}) => {
      const {insGlobal: {cycleId}} = cache.readQuery({query: insGlobal})
      const id = getCacheKey({uuid: cycleId, __typename: "Schedule"})
      const selectedCycle = cache.readFragment({id, fragment: cycleFieldsFragment})

      if (selectedCycle) {
        const selectedQuestions = cache.readFragment({id, fragment: cycleQuestionsFragment, fragmentName: "cycleQuestions"})
        const selectedQuestionGroups = cache.readFragment({id, fragment: cycleQuestionGroupsFragment, fragmentName: "cycleQuestionGroups"})
        const questionGroupId = getPrivateQuestionGroupFromCycle(selectedQuestionGroups)
        const {id: selectedCycleId, ...cycleFields} = cloneDeep(selectedCycle)
        const data = {
          insWizard: {
            cycle: {id: `${CLONE_PREFIX}${selectedCycleId}`, ...cycleFields},
            questions: cloneDeep(selectedQuestions.questions.results).map((q) => ({...q, uuid: `${CLONE_PREFIX}${q.uuid}`})),
            questionGroupId,
            __typename: "InsWizard"
          }
        }
        cache.writeData({data})
      }
    },
    insWizardSyncQuestions: (root, {uuids}, {cache, getCacheKey}) => {
      uuids.forEach((uuid) => {
        const questionCacheKey = getCacheKey({uuid, __typename: "Question"})
        const question = cache.readFragment({id: questionCacheKey, fragment: questionFieldsFragment})
        if (question) {
          const cloneId = `${CLONE_PREFIX}${uuid}`
          const cloneCacheKey = getCacheKey({uuid: cloneId, __typename: "Question"})
          cache.writeFragment({
            id: cloneCacheKey,
            fragment: questionFieldsFragment,
            data: {...question, uuid: `${CLONE_PREFIX}${uuid}`}
          })
        }
      })
    }
  }
}

export default resolvers
